import React, { useState } from "react";
import { Sheet } from "react-modal-sheet";
import "./FilterModal.css";
import BasicCheckbox from "../basicCheckbox/basicCheckbox";
import Btn from "../Btn/Btn";

const FilterModal = ({ 
  isOpen, 
  onClose, 
  onApply, 
  onReset, 
  tariffs, 
  setDisplayedTariffs, 
  setFilterOpen 
}) => {
  const [filters, setFilters] = useState({
    fromWarehouse: false,
    fromDoor: false,
    toWarehouse: false,
    toDoor: false,
  });

  const handleCheckboxChange = (key) => {
    setFilters((prevFilters) => {
        const updatedFilters = {
            ...prevFilters,
            [key]: !prevFilters[key],
        };
        console.log("Обновлённые фильтры:", updatedFilters); // Отладка
        return updatedFilters;
    });
};

const handleApply = () => {
  console.log("Фильтры при применении:", filters); // Отладка
  onApply(filters);
  onClose();
};

const handleReset = () => {
  onReset();
  setFilters({
    fromWarehouse: false,
    fromDoor: false,
    toWarehouse: false,
    toDoor: false,
  });
  setFilterOpen(false); // Закрываем фильтры (если нужно)

  console.log("Фильтры сброшены");
};

  const handleBackdropClick = () => {
    // Если фильтры выбраны, применяем их, иначе просто закрываем
    if (
      filters.fromWarehouse || 
      filters.fromDoor || 
      filters.toWarehouse || 
      filters.toDoor
    ) {
      handleApply();
    } else {
      onClose();
    }
  };

  return (
    <Sheet isOpen={isOpen} onClose={onClose}>
      <Sheet.Backdrop onClick={handleBackdropClick} />
      <Sheet.Container className="filter-modal">
        <Sheet.Content>
          <div className="filter-options-container">
            <div className="filter-header">
              <h3 className="filter-title heading-H5">Фильтр</h3>
              <button className="close-button" onClick={onClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 6L6 18M18 18L6 6"
                    stroke="#C4CADA"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            <div className="filter-options">
              <BasicCheckbox
                label="От склада"
                checked={filters.fromWarehouse}
                onChange={() => handleCheckboxChange("fromWarehouse")}
              />
              <BasicCheckbox
                label="От двери"
                checked={filters.fromDoor}
                onChange={() => handleCheckboxChange("fromDoor")}
              />
              <BasicCheckbox
                label="До склада"
                checked={filters.toWarehouse}
                onChange={() => handleCheckboxChange("toWarehouse")}
              />
              <BasicCheckbox
                label="До двери"
                checked={filters.toDoor}
                onChange={() => handleCheckboxChange("toDoor")}
              />
            </div>
            <div className="filter-actions">
              <Btn onClick={handleApply} text="Применить" width="100%" />
              <Btn
                onClick={handleReset}
                text="Сбросить"
                width="100%"
                subtle
              />
            </div>
          </div>
        </Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
};

export default FilterModal;
